module.exports = __webpack_public_path__ + "static/img/equ3.1e1a9aa7.png";